/* eslint-disable no-console */
import { ReactElement } from 'react';

import { CONTROLLED_PROPS } from './constants';

interface ValidatePropsOptions {
  maxLength?: number;
  mask?: string | (string | RegExp)[];
  maskPlaceholder?: string | null;
  children?: ReactElement;
  [key: string]: unknown;
}

export function validateMaxLength(props: ValidatePropsOptions): void {
  if (props.maxLength && props.mask) {
    console.warn(
      "react-input-mask: maxLength property shouldn't be passed to the masked input. It breaks masking and unnecessary because length is limited by the mask length.",
    );
  }
}

export function validateChildren(
  props: ValidatePropsOptions,
  inputElement: ReactElement,
): void {
  const conflictProps = CONTROLLED_PROPS.filter(
    (propId) =>
      (inputElement.props as ValidatePropsOptions)[propId] != null &&
      (inputElement.props as ValidatePropsOptions)[propId] !== props[propId],
  );

  if (conflictProps.length) {
    console.error(
      `react-input-mask: the following props should be passed to the InputMask component, not to children: ${conflictProps.join(
        ',',
      )}`,
    );
  }
}
